import * as React from 'react';
import {
  Create,
  SimpleForm,
} from 'react-admin';
import ProductSubGroupForm from './ProductSubGroupForm';
import FormToolbar from '../shared/FormToolbar';

const redirect = basePath => basePath.replace('product_subgroups', 'product_groups');

const ProductSubGroupCreate = props => (
  <Create {...props}>
    <SimpleForm
      toolbar={<FormToolbar />}
      redirect={redirect}
    >
      <ProductSubGroupForm {...props} />
    </SimpleForm>
  </Create>
);

export default ProductSubGroupCreate;
